<template>
  <div justify="center">
    <v-card flat>
      <v-card-title class="pa-0 pt-4 pl-5">
        <span>ตั้งค่าการลงชื่อเข้าใช้</span>
      </v-card-title>
      <v-card-title class="pa-0 pt-2 pl-5 pb-4">
        <img src="../../assets/img/linemd.png" width="60px" />
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-checkbox
            v-model="surveyform.enableAuth"
            label="ยืนยันตัวตนผ่าน OneID"
            :disabled="!SPermission.update"
          ></v-checkbox>
          <v-checkbox
            v-model="surveyform.enableOneTime"
            v-if="!(!surveyform.enableAuth || !SPermission.update)"
            label="ทำแบบสอบถามได้ครั้งเดียว"
            hint="ผู้ตอบต้องยืนยันตัวตนก่อนทำแบบสอบถาม"
            persistent-hint
          ></v-checkbox>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// import Swal from "sweetalert2";
export default {
  props: ["surveyform"],
  watch: {
    surveyform: {
      immediate: true,
      deep: true,
      handler() {
        if (!this.surveyform.enableAuth) {
          this.surveyform.enableOneTime = false;
        }
      },
    },
  },
  computed: {
    SPermission() {
      return this.$store.state.user_permission.survey;
    },
  },
};
</script>
